<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="1200px"
    transition="fab-transition"
  >
    <v-card
      style="
        background-image: linear-gradient(#00587d, black);
        box-shadow: inset 0px 0px 0 2000px rgba(0, 88, 125, 0.5);
      "
    >
      <v-card-title
        class="justify-center word_break"
        style="color: #ffffff;"
      >
        <p style="font-size: 15px">
          Next Off Stack, Color Cannot Be Selected (please review
          <a target="_blank" style="color: #6dbe45" :href="samplePicsHref"
            >sample photos</a
          >
          before making your selection).
          <br />
          Delivery 4-7 business days
        </p>
      </v-card-title>
      <v-card-text>
        <br />
        <div id="neworused" v-if="OTCItem && WWTITem">
          <label class="grow">
            <input
              type="radio"
              id="OTCItem"
              :value="OTCItem"
              v-model="finalItem"
              @change="addCart()"
            />
            <img :src="OTCItem.image" alt="One Trip logo" width="60%" />
            <figcaption style="font-size: 16px">
              <h6 style="margin-top: 10px">
                {{ OTCItem.title }} - {{ OTCItem.condition }}
              </h6>
              <h5 class="word_break">
                Price: ${{ format(OTCItem.price) }} Delivery: ${{
                  format(OTCItem.haulingPrice)
                }}
              </h5>
            </figcaption>
          </label>
          <label class="grow">
            <input
              type="radio"
              id="WWTITem"
              :value="WWTITem"
              v-model="finalItem"
              @change="addCart()"
            />
            <img :src="WWTITem.image" alt="Used logo" width="60%" />
            <figcaption style="font-size: 16px">
              <h6 style="margin-top: 10px">
                {{ WWTITem.title }} - {{ WWTITem.condition }}
              </h6>
              <h5 class="word_break">
                Price: ${{ format(WWTITem.price) }} Delivery: ${{
                  format(WWTITem.haulingPrice)
                }}
              </h5>
            </figcaption>
          </label>
        </div>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn text color="#6dbe45" @click="dialog = false" class="btns"
          >Close
          <v-icon color="#6dbe45">mdi-close-circle</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as country_based_data from "@/JS/CountryBasedData";
import { formatNumber } from "@/JS/FormatNumber";
import * as types from "@/store/types";

export default {
  name: "RTO_Model",
  computed: {
    ...mapGetters({
      COUNTRY_CODE: types.COUNTRYCODE,
      containers_list: types.CONTAINER_LIST,
    }),
  },
  data: () => ({
    dialog: false,
    samplePicsHref: "",
    SKU: "",
    finalItem: null,
    OTCItem: null,
    WWTITem: null,
    formattedSku: "",
  }),
  methods: {
    ...mapActions({
      resetCart: types.ACTIONS_UPDATE_RESETCART,
      addCartItem: types.ACTIONS_UPDATE_CART_LIST,
    }),
    open(SKU) {
      this.formattedSku = SKU;
      this.finalItem = null;
      this.skipFortyFiveContainer();
      this.dialog = true;
      this.OTCItem = null;
      this.WWTITem = null;
      this.initializeCountryBasedHref();
      this.initializeContainers();
    },
    initializeCountryBasedHref() {
      if (this.COUNTRY_CODE === "US")
        this.samplePicsHref = country_based_data.USASamplePhotos;
      else if (this.COUNTRY_CODE === "CA")
        this.samplePicsHref = country_based_data.CanadaSamplePhotos;
    },
    /*
    If the SKU is 45' then skip the model and move to RTO form directly.
    45' cannot be bought as OTC, so add 45HCWWT to the cart.
    */
    skipFortyFiveContainer() {
      if (!this.formattedSku.includes("45")) return;

      this.SKU = this.formattedSku + "WWT";
      for (var key in this.containers_list.products) {
        if (key.endsWith(this.SKU)) {
          this.finalItem = {
            image: this.containers_list["products"][key][0]["image_url"],
            sku: this.containers_list["products"][key][0]["sku"],
            title: this.containers_list["products"][key][0]["container_size"],
            formattedSku: this.formattedSku,
            price: this.containers_list["products"][key][0]["container_price"],
            condition: this.containers_list["products"][key][0]["condition"],
            id: this.containers_list["products"][key][0]["id"],
            haulingPrice: this.containers_list["products"][key][0][
              "hauling_price"
            ],
            market_city: this.containers_list["products"][key][0][
              "market_city"
            ],
            depot_address_fields: this.containers_list["products"][key][0][
              "depot_address_fields"
            ],
            availableForSale: this.containers_list["products"][key][0][
              "availableForSale"
            ],
          };
          this.addCart();
        }
      }
    },
    initializeContainers() {
      let item = {};

      for (var key in this.containers_list.products) {
        item = {
          image: this.containers_list["products"][key][0]["image_url"],
          sku: this.containers_list["products"][key][0]["sku"],
          title: this.containers_list["products"][key][0]["container_size"],
          formattedSku: this.formattedSku,
          price: this.containers_list["products"][key][0]["container_price"],
          condition: this.containers_list["products"][key][0]["condition"],
          id: this.containers_list["products"][key][0]["id"],
          haulingPrice: this.containers_list["products"][key][0][
            "hauling_price"
          ],
          market_city: this.containers_list["products"][key][0]["market_city"],
          depot_address_fields: this.containers_list["products"][key][0][
            "depot_address_fields"
          ],
          availableForSale: this.containers_list["products"][key][0][
            "availableForSale"
          ],
        };

        if (key.endsWith(this.formattedSku + "OTC")) this.OTCItem = item;
        else if (key.endsWith(this.formattedSku + "WWT")) this.WWTITem = item;
      }
    },
    addCart() {
      this.resetCart();
      var customAttributes = {
        CSCSurveyRequired: false,
        Type: this.type,
        Purpose: "STORAGE",
        Delivery: "DELIVERY",
      };
      this.finalItem["quantity"] = 1;
      this.finalItem["customAttributes"] = customAttributes;
      this.addCartItem(this.finalItem);
      this.$router.push("/rto_quote?redirect=purchase");
    },
    format(num) {
      return formatNumber(num);
    },
  },
};
</script>

<style scoped>
.btns {
  text-decoration: none;
  font-weight: 700;
  text-transform: unset !important;
  border-radius: 15px;
  margin: 15px;
}

.btns i {
  max-width: 0;
  transition: max-width 0.5s;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  margin-left: 10px;
}

.btns:hover i {
  max-width: 15rem;
  transition-delay: 0.1s;
}

input[type="radio"] {
  display: none;
}

input[type="radio"]:checked + img {
  border: 6px solid #6dbe45;
}

[type="radio"] + img {
  cursor: pointer;
  border-radius: 10px;
}

figcaption {
  color: #ffffff;
  padding: 10px;
}

.word_break{
  white-space: pre-wrap; 
  word-break: break-word;
}
</style>